import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";

const RecentLeads = ({ leadsStats }) => {
  const recentLeads = leadsStats?.recentLeads || [];

  return (
    <React.Fragment>
      <Col lg={4}>
        <Card>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h4 className="card-title mb-0">Últimos Leads</h4>
              <span className="badge bg-primary-subtle text-primary">
                {recentLeads.length}
              </span>
            </div>

            <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <table className="table table-nowrap align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th scope="col" style={{ fontSize: "12px" }}>Lead</th>
                    <th scope="col" style={{ fontSize: "12px" }}>Fecha</th>
                    <th scope="col" style={{ fontSize: "12px", width: "60px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {recentLeads.length === 0 ? (
                    <tr>
                      <td colSpan="3" className="text-center text-muted py-4">
                        No hay leads recientes
                      </td>
                    </tr>
                  ) : (
                    recentLeads.map((lead, key) => (
                      <tr key={key}>
                        <td>
                          <div>
                            <p className="mb-1 fw-medium" style={{ fontSize: "13px" }}>
                              {lead.name} {lead.lastName}
                            </p>
                            <p className="text-muted mb-1" style={{ fontSize: "11px" }}>
                              {lead.email}
                            </p>
                            {lead.listName && (
                              <span className="badge bg-primary-subtle text-primary" style={{ fontSize: "10px" }}>
                                {lead.listName}
                              </span>
                            )}
                          </div>
                        </td>
                        <td>
                          <span className="text-muted" style={{ fontSize: "11px" }}>
                            {lead.createdAt
                              ? moment(lead.createdAt).format("DD/MM/YY")
                              : "-"}
                          </span>
                        </td>
                        <td>
                          <Link to={`/leads/${lead.id}`}>
                            <button
                              type="button"
                              className="btn btn-soft-primary btn-sm"
                              style={{ padding: "4px 8px" }}
                            >
                              <i className="ri-eye-line"></i>
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default RecentLeads;

